import FoodCategory from '@components/offer/models/FoodCategory';
import { ButtonBase } from '@mui/material';
import { grey } from '@mui/material/colors';
import { observer } from 'mobx-react-lite';
import React from 'react';

interface FoodCategoryBaseListItemProps {
    foodCategory: FoodCategory;
    children: React.ReactNode;
    onClick: (foodCategory: FoodCategory) => void
}

const FoodCategoryBaseListItem: React.FC<FoodCategoryBaseListItemProps> = observer(({ foodCategory, onClick, children }) => {
    const isSelected = foodCategory.isSelected;
    return (
        <ButtonBase
            onClick={() => onClick(foodCategory)}
            sx={(theme) => ({
                width: "100%",
                backgroundColor: isSelected ? theme.palette.secondary.light : "Background",
                borderRadius: 0.5,
                ":hover": {
                    background: grey[100]
                }
            })}>
            {children}
        </ButtonBase>
    )
})

export default FoodCategoryBaseListItem;